import { apiClient } from './client'
import type { ApiResponse } from '@/types/api'

// ============================================================================
// Types
// ============================================================================

export type SubscriptionType = 'one_time' | 'monthly' | 'quarterly' | 'yearly' | 'trial'
export type SubscriptionStatus = 'active' | 'paused' | 'expired' | 'cancelled' | 'suspended'

export interface SubscriptionResponse {
  id: number
  orderId: number
  productId: number
  productName: string | null
  curriculumContentId: number | null
  curriculumTitle: string | null
  subscriptionType: SubscriptionType
  status: SubscriptionStatus
  maxSeats: number
  usedSeats: number
  validFrom: string
  validUntil: string | null
  autoRenew: boolean
  activatedAt: string | null
  createdAt: string | null
}

export interface ActiveSubscriptionCheck {
  hasActiveSubscription: boolean
  subscriptions: SubscriptionResponse[]
  message: string
}

// ============================================================================
// API Functions
// ============================================================================

export const subscriptionApi = {
  /**
   * 내 구독 상태 확인
   */
  checkMySubscription: async (): Promise<ActiveSubscriptionCheck> => {
    const response = await apiClient.get<ApiResponse<ActiveSubscriptionCheck>>('/subscriptions/check')
    if (!response.data.data) {
      throw new Error('Failed to check subscription')
    }
    return response.data.data
  },

  /**
   * 내 구독 목록 조회
   */
  getMySubscriptions: async (page = 0, size = 10): Promise<SubscriptionResponse[]> => {
    const response = await apiClient.get<ApiResponse<SubscriptionResponse[]>>(
      `/subscriptions?page=${page}&size=${size}`
    )
    return response.data.data || []
  }
}

